import Base from './Base';
import Helper from '../Helper';
import Product from '../../Stores/Product';
import Option from '../../Components/Widgets/Option.svelte';

export default class Upsell extends Base {
	build(list) {
		const property = this.product().property;
		const selected = property.selected || {};
		if (Array.isArray(property.groups))
			for (let group of property.groups)
				if (Product.visibleGroup(property, group)) {
					const percentage = Product.variationPercentage(group.values.percentage) || Product.variationPercentage(group.percentage);
					const price = group.values.price || group.price || percentage;
					const current = this.current(group, selected);
					const component = {
						component: Option,
						config: {
							id: group.values.id,
							title: group.name,
							badge: group.badge,
							active: !!current.label,
							count: !group.checkbox,
							checked: !!current.count,
							price,
							price_high: group.values.price_from || group.price_from || 0,
							image: this.validImage(group.values.image || group.image),
							description: group.values.description || group.description,
							on_input: item => { this.onChange(item, group, selected); },
							on_click: item => { this.onChange(item, group, selected); },
							on_change: item => { this.onChange(item, group, selected); }
						}
					};

					if (group.list_departments) {
						component.config.options = [];
						const options = component.config.options;
						options.push({value: 0, label: `Niet ${group.name}`});

						const departments = this.product().departments;
						for (let department of departments)
							options.push({value: department.id, label: department.name, department: true});
					}

					const options = component.config.options && component.config.options.length;
					component.config.value = options ? current.value : (current.count || 0);
					list.push(component);
				}

		return list;
	}

	current(group, selected) {
		let current = {};
		if (selected.data)
			for (let item of selected.data)
				if (item.id === group.values.id)
					{ current = item; break; }

		return current;
	}

	onChange(item, group, selected) {
		item.group = group.id;

		if (!selected.data) selected.data = [];
		const search = current => current.id === item.id;
		const found = selected.data.findIndex(search);
		if (found !== -1) {
			if (item.count) selected.data[found] = item;
			else selected.data.splice(found, 1);
		}
		else if (item.count)
			selected.data.push(item);

		if (selected.data.length) {
			let label = '';
			let price = 0;
			for (let current of selected.data) {
				price += parseFloat(current.price);
				if (label) label += ` & ${current.label}`;
				else label = current.label;
				if (current.selection)
					label += ` - ${current.selection}`;
			}

			selected.valid =  true;
			selected.state = 'success';
			selected.value = 0;
			selected.label = label;
			selected.price = price;
		}
		else selected = {};

		this.product().property.selected = selected;
		this.update(true);
	}
}